import React, { useState } from 'react';

/**
 * NetworkStatus - Banner that shows network connectivity status
 * 
 * Props:
 * - isOnline: boolean
 * - isReconnecting: boolean
 * - queuedCount: number of queued messages
 * - onDismiss: optional callback when user dismisses banner
 */
export const NetworkStatus = ({ 
  isOnline, 
  isReconnecting, 
  queuedCount = 0,
  onDismiss 
}) => {
  const [isDismissed, setIsDismissed] = useState(false);

  // Don't show if online or dismissed
  if (isOnline || isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
    if (onDismiss) onDismiss();
  };

  return (
    <div
      className="ov-network-status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: isReconnecting ? '#FFA500' : '#F87171',
        color: '#FFFFFF',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        animation: 'slideDown 0.3s ease-out',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {isReconnecting ? (
          <>
            <span style={{ fontSize: '20px', animation: 'spin 1s linear infinite' }}>⟳</span>
            <span>Reconnecting...</span>
          </>
        ) : (
          <>
            <span style={{ fontSize: '20px' }}>⚠️</span>
            <span>
              You're offline. 
              {queuedCount > 0 && ` ${queuedCount} message${queuedCount > 1 ? 's' : ''} queued.`}
            </span>
          </>
        )}
      </div>
      
      {!isReconnecting && (
        <button
          onClick={handleDismiss}
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            color: '#FFFFFF',
            padding: '4px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '600',
            transition: 'background 0.2s',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.2)';
          }}
        >
          Dismiss
        </button>
      )}
      
      <style>{`
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default NetworkStatus;
